import i18next from 'i18next';

export const renewablePlan = 'tmu_us_2026';
export const nonRenewablePlan = 'tmu_us_2026_no_renew';
export const certificationsOnlyPlan = 'tmu_us_2026_certifications_only';

export const getSubscription = (price: number) => ({ id: 'premium', title: i18next.t('Trackman University Subscription', { ns: 'webshop' }), price });
